import type { ReactNode } from 'react';

type VerifyStatus = '待验证' | '部分验证' | '已验证' | '已排除';
type Priority = '高' | '中' | '低';
type EvidenceLevel = '充分' | '部分' | '不足';

const verifyStyle: Record<VerifyStatus, string> = {
  待验证: 'bg-background-200 text-foreground-700 border-background-300',
  部分验证: 'bg-accent-100 text-accent-900 border-accent-200',
  已验证: 'bg-primary-100 text-primary-800 border-primary-200',
  已排除:
    'bg-secondary-100 text-secondary-700 border-secondary-200 line-through decoration-secondary-400',
};

const priorityStyle: Record<Priority, string> = {
  高: 'bg-accent-500 text-background-50 border-accent-600',
  中: 'bg-primary-100 text-primary-800 border-primary-200',
  低: 'bg-secondary-100 text-secondary-700 border-secondary-200',
};

const evidenceStyle: Record<EvidenceLevel, string> = {
  充分: 'bg-primary-100 text-primary-800 border-primary-200',
  部分: 'bg-accent-100 text-accent-900 border-accent-200',
  不足: 'bg-background-200 text-foreground-600 border-background-300',
};

export function Pill({
  children,
  className = '',
  icon,
}: {
  children: ReactNode;
  className?: string;
  icon?: string;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${className}`}
    >
      {icon ? <i className={`${icon} text-[11px]`} /> : null}
      {children}
    </span>
  );
}

export function VerifyPill({ value }: { value: string }) {
  const style = verifyStyle[value as VerifyStatus] ?? verifyStyle.待验证;
  return <Pill className={style}>{value}</Pill>;
}

export function PriorityPill({ value }: { value: string }) {
  const style = priorityStyle[value as Priority] ?? priorityStyle.中;
  return (
    <Pill className={style} icon="ri-flag-line">
      优先级 {value}
    </Pill>
  );
}

export function LeadTypePill({ value }: { value: string }) {
  return (
    <Pill className="border-secondary-200 bg-secondary-50 text-secondary-800">{value}</Pill>
  );
}

export function EvidencePill({ value }: { value: string }) {
  const style = evidenceStyle[value as EvidenceLevel] ?? evidenceStyle.不足;
  return <Pill className={style}>证据 {value}</Pill>;
}
